<!-- =========================================================================================
    File Name: Data.vue
    Description: pivot table for reports
    ----------------------------------------------------------------------------------------
    Item Name:
      Author:
    Author URL:
========================================================================================== -->
<template>
  <div>
    <reports-tool-bar
      @bulk-selection="fetchData($event)"
      @preset="fetchData($event)"
      @clear-selection="clearSelection($event)"
      @download-csv="downloadCsv($event)"
    />
    <!-- <reports-shower v-if="entityText && entityIcon"
      :text="entityText"
      :icon="entityIcon"
      :count="pivotData.length"
      :stats="pivotData.stats"
    /> -->
    <div class="container w-full" style="min-height: 1000px !important;">
    <!--
      Solution with custom Pivot Table
    -->
      <vue-pivottable-ui
        :data="pivotData"
        :rows="pivotRows"
        :cols="pivotCols"
        :rowTotal="false"
        :locales="locales"
        :locale="locale"
        renderer-name="Tabella"
        :renderers="renderers"
        :aggregator-name="pivotAggr"
      >
      </vue-pivottable-ui>
    <!--
      Solution with PowerBi iframe
    -->
      <!-- <iframe
        class="responsive-iframe"
        src="https://app.powerbi.com/reportEmbed?reportId=055ac8a2-90bc-42ac-8bc2-f026599fb19f&autoAuth=true&ctid=cc1660c3-0511-40e7-b4b9-ea607266b90d&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtZXVyb3BlLWQtcHJpbWFyeS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ=="
        frameborder="0" allowFullScreen="true">
      </iframe> -->
    </div>
  </div>
</template>
<script>
import ReportsToolBar from '../../components/ReportsToolBar.vue'
// import ReportsShower from '../../components/ReportsShower.vue'
import { VuePivottableUi } from 'vue-pivottable'
import PlotlyRenderer from '@vue-pivottable/plotly-renderer'
import ScrollRenderer from '@vue-pivottable/scroll-renderer'
import 'vue-pivottable/dist/vue-pivottable.css'
import { PivotUtilities } from "vue-pivottable";

export default {
  components: {
    VuePivottableUi,
    ReportsToolBar,
    // ReportsShower,
    PlotlyRenderer,
    ScrollRenderer
  },
  computed: {
    renderers () {
      return (() => ({
        'Tabella' : ScrollRenderer.Table,
        'Tabella Heatmap': ScrollRenderer['Table Heatmap'],
        'Tabella Collonne Heatmap': ScrollRenderer['Table Col Heatmap'],
        'Tabella Righe Heatmap': ScrollRenderer['Table Row Heatmap'],
        'Grouped Collonne Grafico': PlotlyRenderer['Grouped Column Chart'],
        'Stacked Collonne Grafico': PlotlyRenderer['Stacked Column Chart'],
        'Grouped Barre Grafico': PlotlyRenderer['Grouped Bar Chart'],
        'Stacked Barre Grafico': PlotlyRenderer['Stacked Bar Chart'],
        'Line Grafico': PlotlyRenderer['Line Chart'],
        'Dot Grafico': PlotlyRenderer['Dot Chart'],
        'Area Grafico': PlotlyRenderer['Area Chart'],
        'Scatter Grafico': PlotlyRenderer['Scatter Chart'],
        'Multiple Pie Grafico': PlotlyRenderer['Multiple Pie Chart']
      }))()
    }
  },
  data() {
    return {
    // data pivot
      pivotData: [],
      pivotRows: [],
      pivotCols: [],
      pivotAggr: 'Count',
      // entityText: '',
      // entityIcon: '',

    // pivot settings
      locale: "it",
      locales: {
        // en: PivotUtilities.locales.en,
        it: {

// https://seungwoo321.github.io/vue-pivottable/guide/
          aggregators: PivotUtilities.aggregators,
          localeStrings: {
            renderError: 'Errore nel render dei risultati in PivotTable.',
            computeError: 'Errore nel calcolo dei risultati per PivotTable.',
            uiRenderError: 'Errore nel render dell\'UI in PivotTable.',
            selectAll: 'Seleziona tutti',
            selectNone: 'Pulisci selezione',
            tooMany: '(troppi per la lista)',
            filterResults: 'Filtra valori',
            totals: 'Totali',
            vs: 'vs',
            by: 'by'
          },
        },
      }
    }
  },
  // mounted() {
  //   // this.getAziende()
  //   // this.getPreventivi()
  // },

  methods: {
    downloadCsv(object) {
      let csvData = object.fields.join(',') + '\n';
      console.log(object,csvData)
      csvData += this.pivotData.map(entry => {

        const row = object.fields.map(field => {
          if (field === 'voci') {
            return entry[field].join('; '); // Use ';' as separator for 'voci'
          }
          if (field === 'voci importo') {
            return entry[field].join('; '); // Use ';' as separator for 'voci'
          }
          return entry[field]
        });
        return row.join(',');
        // return row
        // return [
        //   entry["importo finale"],
        //   entry["sconto percentuale"],
        //   entry["voci"].join(", "),
        //   entry["voci importo"].join(", "),
        //   entry["tariffa"],
        //   entry["servizio"],
        //   entry["pacchetto"],
        //   entry["mese emissione"],
        //   entry["anno emissione"],
        //   entry["stato"],
        //   entry["creatore"],
        //   entry["responsabile"],
        //   entry["contatto"],
        //   entry["azienda"],
        //   entry["ufficio"]
        // ];
      }).join('\n');

      console.log(object,csvData)

      // Create a blob with CSV content
      const blob = new Blob([csvData], { type: 'text/csv' });

      // Create a link element
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      // Set the filename for the downloaded CSV file
      link.download = object.filename+'.csv';

      // Simulate a click to trigger the download
      link.click();
    },
    fetchData(obj) {
      this.getData(obj)
    },
    getData(obj) {
      /*
        obj {
          path: controller/endpoint to be used
          year: year of selection
        }
      */
      // console.log('page with request ',obj,year);
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      axios
      .post(process.env.VUE_APP_BACKEND_API+obj.path,{
        user:obj.user,
        month:obj.month,
        // year:obj.year,
        // keyword:obj.keyword
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
      })
      .then(response => {
        // this.entityText = obj.text
        // this.entityIcon = obj.icon
        if (response.data.length == 0) {
          this.pivotData = []
          this.$vs.notify({
            color: 'warning',
            time: 4000,
            title: ['Nessun risultato'].join(' '),
            text: ['Filtri applicati con successo, trovato nessun dato'].join(' ')
          })
        }
        else {
          this.pivotData = response.data
          this.pivotData['stats'] = {
            previous: response.data.filter( el => el.data_emissione_anno === obj.year -1 ).length,
            current: response.data.filter( el => el.data_emissione_anno === obj.year ).length,
            next: response.data.filter( el => el.data_emissione_anno === obj.year +1 ).length,
            year: obj.year,
          }
          this.pivotRows = obj.rows
          this.pivotCols = obj.cols
          this.pivotAggr = obj.aggr
        }
        this.$vs.loading.close()
      })
      .catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
    },
    changePreset(obj) {
      this.pivotRows = obj.rows
      this.pivotCols = obj.cols
      this.pivotAggr = obj.aggr
    },
    clearSelection(ev) {
      this.pivotData= []
      this.pivotRows= []
      this.pivotCols= []
      this.pivotAggr= 'Count'
      if (ev) ev.stopPropagation()
    },
  }
};
</script>

<style>
.container {
  max-width: none !important;
  position: relative;
  overflow: hidden;
  width: 100%;
  padding: none !important;
}
/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
